// Exclude each marked process and all materials belonging to that process.
export function productionOverheadLines(items = []) {
  return items.flatMap(item => (item.cost_lines || []).filter(line => {
    const parent = line.line_type === 'material' && line.process_source_line_id && (item.cost_lines || []).find(process => process.line_type === 'process' && process.source_line_id === line.process_source_line_id);
    return Boolean(line.process?.is_overhead ?? parent?.process?.is_overhead ?? parent?.is_overhead ?? line.is_overhead);
  }).map(line => ({
    ...line, article: item.product_code_snapshot || '',
  })));
}
export function overheadTotal(lines = []) {
  return Number(lines.reduce((sum, line) => sum + Number(line.total_cost || 0), 0).toFixed(4));
}
